import { getAllGameQuery } from 'dataLayer/game'
import { gameListAtom } from 'config/store'
import { useAtom } from 'jotai'
import GameCard from 'layout/MainLayout/components/GameCard'
import SearchBar from 'pages/HomePage/components/SearchBar'
import { Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { memo, useEffect, useState } from 'react'

function OtherGame() {
	const { t } = useTranslation()
	const { roomId } = useParams()
	const [valueSearch, setValueSearch] = useState('')
	const [listGame, setListGame] = useState([])
	const [itemSelect, setItemSelect] = useState({})
	const { data: games } = useQuery(getAllGameQuery())
	// TODO: Implement draggable other games list
	let listGameSelect =
		games && Array.isArray(games) && games.filter(it => it.id != roomId)
	useEffect(() => {
		if (listGameSelect) {
			setListGame(listGameSelect)
		} else {
			setListGame([])
		}
	}, [games])
	useEffect(() => {
		let listGame =
			games &&
			Array.isArray(games) &&
			games.filter(it => it.id != itemSelect.id)
		setListGame(listGame)
	}, [itemSelect])
	useEffect(() => {
		let resultSearch =
			listGameSelect &&
			Array.isArray(listGameSelect) &&
			listGameSelect.filter(it =>
				it.name.toLowerCase().includes(valueSearch.toLowerCase()),
			)
		setListGame(resultSearch)
	}, [valueSearch])
	const handleSearch = e => {
		setValueSearch(e.target.value)
	}
	return (
		<Container fluid className="other-game-container">
			<Row className="justify-content-between align-items-center">
				<h1 className="other-game-title">{t('room.other_game')}</h1>
				<div className="search-bar search-bar__other-game">
					<SearchBar
						type="text"
						value={valueSearch}
						placeholder={t('search_bar')}
						onChange={handleSearch}
						onPaste={e => e.preventDefault()}
					// onDrop={e => e.preventDefault()}
					/>
				</div>
			</Row>
			<Row className="mt-1 g-3">
				{listGame && Array.isArray(listGame) && listGame.length > 0 ? (
					listGame?.map(item => (
						<Col xs={6} sm={6} lg={3} className="pe-2 px-0 px-sm-2">
							<GameCard
								key={item.id}
								data={item}
								isSmall={true}
								padding="py-3 px-2"
								setItemSelect={setItemSelect}
							/>
						</Col>
					))
				) : (
					<div>
						<p className="other-game-no-data">{t('room.list-game-no-data')}</p>
					</div>
				)}
			</Row>
		</Container>
	)
}

export default memo(OtherGame)
